import { SectionWrapper } from "./style";
import { Container } from "semantic-ui-react";
import Title from "assets/graphics/הבית הטרנסי/לוגו הבית הטרנסיmdpi.svg";
import { Fade } from "react-awesome-reveal";
import { useStore } from "structure";
import { observer } from "mobx-react-lite";

export const AboutSection = observer(() => {
  const { wpPages } = useStore();
  const page = wpPages.find((page) => page.slug === "trans-content");
  return (
    <SectionWrapper>
      <Container>
        <div className="ls-main">
          <div>
            <Fade direction="right" triggerOnce={true}>
              <h2>
                <img src={Title} alt="הבית הטרנסי" className="section-title" />
              </h2>
            </Fade>
          </div>

          <div className="ls-content">
            <Fade direction="left" cascade damping={0.1} triggerOnce={true}>
              {page && (
                <div
                  dangerouslySetInnerHTML={{ __html: page.content.rendered }}
                />
              )}
            </Fade>
          </div>
        </div>
      </Container>
    </SectionWrapper>
  );
});
